"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var RawExampleFloatingInput_1 = require("./RawExampleFloatingInput");
var IconAndPlaceholderExampleFloatingInput_1 = require("./IconAndPlaceholderExampleFloatingInput");
var PropertiesFloatingInput_1 = require("./PropertiesFloatingInput");
exports.ComponentFloatingInputPage = function () { return (React.createElement(common_1.Page, { headerText: "Floating Input" },
    React.createElement(common_1.Paragraph, null, "Floating Input is a beautiful rounded input that can be used for, for example, search."),
    React.createElement(common_1.TopicHeader, null, "Examples"),
    React.createElement(RawExampleFloatingInput_1.RawExampleFloatingInput, null),
    React.createElement(IconAndPlaceholderExampleFloatingInput_1.IconAndPlaceholderExampleFloatingInput, null),
    React.createElement(common_1.TopicHeader, null, "Properties"),
    React.createElement(PropertiesFloatingInput_1.PropertiesFloatingInput, null))); };
exports.ComponentFloatingInputPage.displayName = 'ComponentFloatingInputPage';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentFloatingInputPage/ComponentFloatingInputPage.tsx
// module id = 673
// module chunks = 0